import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import { Row, Col, Card, Select, Typography } from 'antd';
import WipInbOrdTable from './WipInbOrdTable';
import WipGdsRcptTable from './WipGdsRcptTable';
import WipWhseJobTable from './WipWhseJobTable';
import CompleteGdsRcptTable from './CompleteGdsRcptTable';
import WipWhseJobDialog from './WipWhseJobDialog';
import WipGdsRcptDialog from './WipGdsRcptDialog';
import WipInbOrdDialog from './WipInbOrdDialog';
import CompleteGdsRcptDialog from './CompleteGdsRcptDialog';

import GdsRcptDetailBoardActions from '../../Stores/GdsRcptDetailBoard/Actions';

const { Option } = Select;
const { Text } = Typography;

class GdsRcptDetailBoardScreen extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      intervalId: 0,
      // milisecond
      refreshInterval: 300000
    };

    this.handleInterval = this.handleInterval.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  componentDidMount() {
    const { refreshInterval } = this.state;

    if (refreshInterval > 0) {
      const intervalId = setInterval(this.handleInterval, refreshInterval);
      this.setState({
        intervalId
      });
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    const { intervalId } = this.state;

    clearInterval(intervalId);
  }

  handleInterval() {
    const {
      resetWipInbOrdTimestamp,
      resetGdsRcptTimestamp,
      resetWipWhseJobTimestamp,
      resetCompleteGdsRcptTimestamp
    } = this.props;

    resetWipInbOrdTimestamp();
    resetGdsRcptTimestamp();
    resetWipWhseJobTimestamp();
    resetCompleteGdsRcptTimestamp();
  }

  handleSelectChange(value) {
    let { intervalId } = this.state;

    this.setState({
      refreshInterval: value
    });

    clearInterval(intervalId);

    if (value > 0) {
      intervalId = setInterval(this.handleInterval, value);

      this.setState({
        intervalId
      });
    }
  }

  render() {
    const { intl, match, wipInbOrdTimestamp } = this.props;
    const { refreshInterval } = this.state;

    return (
      <Card
        title={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <>
            <Text>{intl.formatMessage({ id: 'gds_rcpt_details_kanban_board' })}</Text>
            <br />
            <small>
              {`${intl.formatMessage({ id: 'last_updated' })} ${moment(wipInbOrdTimestamp).format(
                'YYYY-MM-DD HH:mm:ss'
              )}`}
            </small>
          </>
        }
        extra={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <Select value={refreshInterval} onChange={this.handleSelectChange} style={{ width: 75 }}>
            <Option value={0}>{intl.formatMessage({ id: 'off' })}</Option>
            <Option value={30000}>30s</Option>
            <Option value={60000}>1min</Option>
            <Option value={120000}>2min</Option>
            <Option value={300000}>5min</Option>
          </Select>
        }
      >
        <Row type="flex" justify="center" gutter={[16, 8]}>
          <Col span={6}>
            <WipInbOrdTable match={match} />
            <WipInbOrdDialog match={match} />
          </Col>
          <Col span={6}>
            <WipGdsRcptTable match={match} />
            <WipGdsRcptDialog match={match} />
          </Col>
          <Col span={6}>
            <WipWhseJobTable match={match} />
            <WipWhseJobDialog match={match} />
          </Col>
          <Col span={6}>
            <CompleteGdsRcptTable match={match} />
            <CompleteGdsRcptDialog match={match} />
          </Col>
        </Row>
      </Card>
    );
  }
}

GdsRcptDetailBoardScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  wipInbOrdTimestamp: PropTypes.number,

  resetWipInbOrdTimestamp: PropTypes.func,
  resetGdsRcptTimestamp: PropTypes.func,
  resetWipWhseJobTimestamp: PropTypes.func,
  resetCompleteGdsRcptTimestamp: PropTypes.func
};

GdsRcptDetailBoardScreen.defaultProps = {
  intl: {},
  match: {},
  wipInbOrdTimestamp: 0,

  resetWipInbOrdTimestamp() {},
  resetGdsRcptTimestamp() {},
  resetWipWhseJobTimestamp() {},
  resetCompleteGdsRcptTimestamp() {}
};

const mapStateToProps = state => ({
  wipInbOrdTimestamp: state.gdsRcptDetailBoard.wipInbOrdTimestamp
});

const mapDispatchToProps = dispatch => ({
  resetWipInbOrdTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptDetailBoardActions.gdsRcptDetailBoardResetWipInbOrdTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),
  resetGdsRcptTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptDetailBoardActions.gdsRcptDetailBoardResetWipGdsRcptTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),
  resetWipWhseJobTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptDetailBoardActions.gdsRcptDetailBoardResetWipWhseJobTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),
  resetCompleteGdsRcptTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptDetailBoardActions.gdsRcptDetailBoardResetCompleteGdsRcptTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GdsRcptDetailBoardScreen));
